import { useEffect, useState } from 'react';
import { fetchDosageDiaryProfiles } from '../service/fetchDosageDiaryProfiles';
import showToast from '../components/ToastComponent';
import { DosageDiaryListItem } from '../interface/interface';

export function useToFetchDosageDiaries(token: string, fetchDD: boolean) {
  const [profiles, setProfiles] = useState<Array<DosageDiaryListItem>>();

  useEffect(() => {
    fetchDosageDiaryProfiles(token).then((data) => {
      if (typeof data === 'number') {
        showToast({
          type: 'info',
          message: 'Unable to fetch dosage diary profiles',
        });
        setProfiles([]);
        return;
      }

      setProfiles(data);
    });
  }, [fetchDD, token]);

  return [profiles];
}
